import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image, Button, Form, InputGroup } from "react-bootstrap";
import Email_icon from "../../../assests/images/ls-page-image/email.svg";
import UserIcon from "../../../assests/images/user-icon.svg";
import Key_not_slash_icon from "../../../assests/images/ls-page-image/key-not-slash.svg";
import Key_slash_icon from "../../../assests/images/ls-page-image/key-slash.svg";

import {
    FormBox,
    FormSubmitBtn,
} from "./userSignUpFormStyle";
import { useFormik } from "formik";
import * as Yup from "yup";
import { REGEX } from "../../../utils/constant";
import { MESSAGE } from "../../../utils/message";
import { useDispatch, useSelector } from "react-redux";
import { signupUserAction, signupUserHandler } from "../../../redux/slices/auth/signup-slice";
import { SignUpProps } from "../../../utils/types";
import { useNavigate } from "react-router-dom";
import Mailcheck from "mailcheck";


const SignUPForm = ({ userType }: any) => {
    const [emailSuggestion, setEmailSuggestion] = useState("")

    const dispatch: any = useDispatch();
    const navigate: any = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const signup = useSelector((state: any) => state?.signup);
    const availableModules = useSelector((state: any) => state?.modules?.data?.results);


    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };
    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    
        const { value } = e.target;
        formik.setFieldValue("email", value);

        // Check for domain typos
        Mailcheck.run({
            email: value,
            suggested: function (suggestion: any) {
                setEmailSuggestion(suggestion.full); // Suggest corrected email
            },
            empty: function () {
                setEmailSuggestion(""); // No suggestion
            }
        });
    };

    const handleSelectSuggestion = () => {
        formik.setFieldValue("email", emailSuggestion);
        setEmailSuggestion("");
    };


    useEffect(() => {
        if (signup?.data) {
            if (signup?.data?.status === 200 || signup?.data?.status === 202 || signup?.data?.status === 201)
                setTimeout(() => {
                    signupUserAction.signupSliceReset();
                    navigate("/signin");
                }, 500);
        }
    }, [signup])


    const formik = useFormik<SignUpProps>({
        initialValues: {
            email: '',
            username: '',
            password: '',
            confirm_password: '',
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .trim()
                .matches(/^[a-zA-Z0-9_-]+$/, "Username must contain only letters, numbers, dashes, or underscores")
                .required(MESSAGE.requiredErrors("UserName"))
                .min(4, "Username must be at least 4 character"),
            email: Yup.string().trim()
                .required(MESSAGE.requiredErrors("Email"))
                .matches(REGEX.specificEmailValidate, "Invalid Email Address"),
            password: Yup.string().trim()
                .required(MESSAGE.requiredErrors("Password"))
                .matches(
                    REGEX.passwordValidate,
                    "Password must contain a special character, an uppercase letter, a number, and be at least 8 characters long"
                ),
            confirm_password: Yup.string().trim()
                .required(MESSAGE.requiredErrors("Confirm Password"))
                .oneOf([Yup.ref("password")], "Passwords do not match"),
        }),
        onSubmit: (values: SignUpProps, { resetForm }) => {
            setEmailSuggestion("");
            const data = {
                email: values.email,
                username: values.username,
                password: values.password,
                confirm_password: values.confirm_password,
                type: userType
            };
            dispatch((data));
            resetForm({});
        },
    });


    return (
        <Form className="sign-up-form" onSubmit={formik.handleSubmit}>
            <FormBox>
                <Form.Group className="form-group">
                    <InputGroup>
                        <Form.Control type="email" placeholder="Email address" id="email" name="email" value={formik.values.email} onChange={handleEmailChange} />

                        <InputGroup.Text>
                            <Image src={Email_icon} alt="Email Icon" width="24px" height="24px" />
                        </InputGroup.Text>
                    </InputGroup>
                    {emailSuggestion && (
                        <div className="email-suggestion">
                            Did you mean <strong onClick={handleSelectSuggestion} >
                                {emailSuggestion}
                            </strong>
                        </div>
                    )}
                    {formik.touched.email && formik.errors.email && (
                        <div className="error">
                            <p>{formik.errors.email}</p>
                        </div>
                    )}
                </Form.Group>
                <Form.Group className="form-group">

                    <InputGroup>
                        <Form.Control type="text" placeholder="User Name" id="username" name="username"
                            maxLength={30} value={formik.values.username} onChange={formik.handleChange} />
                        <InputGroup.Text>
                            <Image src={UserIcon} alt="User Icon" width="24px" height="24px" />
                        </InputGroup.Text>
                    </InputGroup>
                    {formik.touched.username && formik.errors.username && (
                        <div className="error">
                            <p>{formik.errors.username}</p>
                        </div>
                    )}
                </Form.Group>
            </FormBox>
            <FormBox>
                <Form.Group className="form-group">
                    <InputGroup>
                        <Form.Control
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            id="password"
                            maxLength={30}
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                        />
                        <InputGroup.Text onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }} >
                            <Image src={showPassword ? Key_slash_icon : Key_not_slash_icon} alt="Toggle Password Visibility" width="24px" height="24px" />
                        </InputGroup.Text>
                    </InputGroup>
                    {formik.touched.password && formik.errors.password && (
                        <div className="error">
                            <p>{formik.errors.password}</p>
                        </div>
                    )}
                </Form.Group>
                <Form.Group className="form-group">
                    <InputGroup>
                        <Form.Control
                            type={showConfirmPassword ? 'text' : 'password'}
                            placeholder="Confirm Password"
                            id="confirm_password"
                            name="confirm_password"
                            value={formik.values.confirm_password}
                            onChange={formik.handleChange}
                        />
                        <InputGroup.Text onClick={toggleConfirmPasswordVisibility} style={{ cursor: 'pointer' }} >
                            <Image src={showConfirmPassword ? Key_slash_icon : Key_not_slash_icon} alt="Toggle Password Visibility" width="24px" height="24px" />
                        </InputGroup.Text>
                    </InputGroup>
                    {formik.touched.confirm_password && formik.errors.confirm_password && (
                        <div className="error">
                            <p>{formik.errors.confirm_password}</p>
                        </div>
                    )}
                </Form.Group>
            </FormBox>
            {availableModules?.user_registration && <FormSubmitBtn>
                <Button variant="primary" type="submit" className="btn-outline-success-blue">{MESSAGE.signUp}
                    {signup?.isLoading && <span className="btnloader"></span>}
                </Button>

            </FormSubmitBtn>}
        </Form>
    );
}
export default SignUPForm;